import { motion } from "framer-motion";
import Chapter from "@/components/Chapter";

const ITEMS = [
  { title: "Premium Quality", sub: "Vetted brands and grades" },
  { title: "Wide Range", sub: "30+ Colours & 3 Designs" },
  { title: "Trusted Supply", sub: "Straight dealing, fair rates" },
  { title: "On-Time Delivery", sub: "Dispatched as promised" },
];

export default function TrustRow() {
  return (
    <div>
      <Chapter no="03" kicker="Why SRS" heading="Built on four promises." />
      <div
        data-testid="trust-row"
        className="grid grid-cols-2 gap-y-12 border-y border-ink/10 py-14 lg:grid-cols-4 lg:py-20"
      >
        {ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            data-testid={`trust-item-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className="border-ink/10 lg:px-10 lg:[&:not(:first-child)]:border-l"
          >
            <span className="font-mono text-[11px] tracking-[0.25em] text-srs">0{i + 1}</span>
            <h3 className="mt-4 font-display text-xl font-semibold tracking-tight text-ink sm:text-2xl">
              {item.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-subtle">{item.sub}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
